export default __webpack_public_path__ + "static/media/Moar-package-right-bg.de1d56fc.png";